import { createSlice } from "@reduxjs/toolkit";
import { HTTPRequest } from "../Api";

const GameSlice = createSlice({
    name: 'game',
    initialState: {
        game: {}
    },
    reducers: {
        setGame: (state, action) => {
            state.game = action.payload;
        }
    }
})

export function createGame(data, completed){
    return (dispatch) => {
        dispatch(HTTPRequest('POST', '/game', data, (result) => {
            dispatch(setGame(result));
            if(typeof(completed) === 'function'){
                completed(result);
            }
        }))
    }
}

export function getGame(id, userId, completed){
    return (dispatch) => {
        dispatch(HTTPRequest('GET', `/game/${id}?userId=${userId}`, {}, (result) => {
            dispatch(setGame(result));
            if(typeof(completed) === 'function'){
                completed(result);
            }
        }))
    }
}

export function joinGame(id, data, completed){
    return (dispatch) => {
        dispatch(HTTPRequest('POST', `/game/join/${id}`, data, (result) => {
            dispatch(getGame(id));
            if(typeof(completed) === 'function'){
                completed();
            }
        }))
    }
}

export function setPlayers(id, players, completed){
    return (dispatch) => {
        dispatch(HTTPRequest('POST', `/game/${id}`, players, (response) => {
            dispatch(getGame(id));
            if(typeof(completed) === 'function'){
                completed();
            }
        }))
    }
}

export function startGame(id, completed){
    return (dispatch) => {
        dispatch(HTTPRequest('POST', `/game/start/${id}`, {}, (response) => {
            dispatch(getGame(id));
            if(typeof(completed) === 'function'){
                completed();
            }
        }))
    }
}

export function makeMove(id, location, userId, card, game, completed){
    return (dispatch, getState) => {
        let body = {
            pos: location,
            userId: userId,
            card: card,
            team: String(game.players.find(user => user.userId === userId).team).toLowerCase()
        }
        dispatch(HTTPRequest('POST', `/game/move/${id}`, body));
    }
}

export const {setGame} = GameSlice.actions;

export const gameSelector = (state) => state.game.game;

export default GameSlice.reducer;